import React from "react";
import { Table, Avatar } from "antd";
import { messages } from "../../../../utils/Common/Messages";
import { getUserData } from "../../../../utils/Helpers";

const Itemsummarylist = ({
  dataSource,
  interval,
  dateColums,
  defaultCurrency,
  summaryType,
  lan,
}) => {
  const dualPricing = getUserData()?.dualPricing ?? false;
  const isRestaurant = getUserData()?.isRestaurant ?? false;
  let columns = [];
  if (interval === "summary") {
    columns =
      dualPricing === "true" || dualPricing === true
        ? [
          {
            icon: "name",
            dataIndex: "name",
            key: "name",
            fixed: "left",
            width: 50,
            padding: "8px 0 8px 10px!important",
            className: "first-p-r-0",
            render: (name) => (
              <>
                <div key={name}>
                  <Avatar className="bg-primary fw-700">
                    {name?.charAt(0)}
                  </Avatar>
                </div>
              </>
            ),
          },
          {
            title: messages.itemName[lan],
            dataIndex: "name",
            key: "name",
            fixed: "left",
            width: 220,
          },
          {
            title: "UPC/PLU",
            dataIndex: "skuupc",
            key: "skuupc",
            align: "left",
          },
          {
            title: messages.category[lan],
            dataIndex: "category",
            key: "category",
            align: "left",
          },
          {
            title: messages.unitsSold[lan],
            dataIndex: "unitsold",
            key: "unitsold",
            align: "right",
          },
          {
            title: messages.productPrice[lan],
            dataIndex: "productPrice",
            key: "productPrice",
            align: "right",
            render: (price) => {
              return <>{defaultCurrency + "" + (price ?? 0)}</>;
            }
          },
          {
            title: messages.salesAmount[lan],
            dataIndex: "amount",
            key: "amount",
            align: "right",
            className: "fw-700",
            render: (price) => {
              return <>{defaultCurrency + "" + price}</>;
            },
          },
          {
            title: "Discount", //tempory renaming to move the ticket as requested by gaurang
            dataIndex: "discountAmount",
            key: "discountAmount",
            align: "right",
            className: "fw-700",
            render: (price) => {
              return <>{price ? defaultCurrency + "" + price : ""}</>;
            },
            // render: (price) => {
            //   return <>{defaultCurrency + "" + Math.abs(Number(price)).toFixed(2)}</>;
            // },
          },
          {
            title: "Dual Pricing Discount",
            dataIndex: "cashDiscountAmount",
            key: "cashDiscountAmount",
            align: "right",
            className: "fw-700",
            render: (price) => {
              return <>{price ? defaultCurrency + "" + price : ""}</>;
            },
            // render: (price) => {
            //   return <>{defaultCurrency + "" + Math.abs(Number(price)).toFixed(2)}</>;
            // },
          },


          {
            title: messages.isTareWeightSupported[lan],
            dataIndex: "isTareWeightSupported",
            key: "isTareWeightSupported",
            align: "right",
          },
          {
            title: messages.tareType[lan],
            dataIndex: "tareType",
            key: "tareType",
            align: "right",
            render: (type) => {
              return (
                <span style={{ textTransform: "capitalize" }}>{type}</span>
              );
            }
          },
          {
            title: messages.tareWeight[lan],
            dataIndex: "packageWeight",
            key: "packageWeight",
            align: "right",
          },
          {
            title: messages.actualWeight[lan],
            dataIndex: "actualWeight",
            key: "actualWeight",
            align: "right",
          },
          {
            title: messages.adjustedWeight[lan],
            dataIndex: "unitsold",
            key: "unitsold",
            align: "right",
          },
          {
            title: messages.UnitofMeasurement[lan],
            dataIndex: "weightUnitCode",
            key: "weightUnitCode",
            align: "right",
          }
        ]
        : [
          {
            icon: "name",
            dataIndex: "name",
            key: "name",
            fixed: "left",
            width: 50,
            padding: "8px 0 8px 10px!important",
            className: "first-p-r-0",
            render: (name) => (
              <>
                <div key={name}>
                  <Avatar className="bg-primary fw-700">
                    {name?.charAt(0)}
                  </Avatar>
                </div>
              </>
            ),
          },
          {
            title: messages.itemName[lan],
            dataIndex: "name",
            key: "name",
            fixed: "left",
            width: 220,
          },
          {
            title: "UPC/PLU",
            dataIndex: "skuupc",
            key: "skuupc",
            align: "left",
          },
          {
            title: messages.category[lan],
            dataIndex: "category",
            key: "category",
            align: "left",
          },
          {
            title: messages.unitsSold[lan],
            dataIndex: "unitsold",
            key: "unitsold",
            align: "right",
          },
          {
            title: messages.productPrice[lan],
            dataIndex: "productPrice",
            key: "productPrice",
            align: "right",
            className: "fw-700",
            render: (price) => {
              return <>{defaultCurrency + "" + (price ?? 0)}</>;
            },
          },
          {
            title: messages.salesAmount[lan],
            dataIndex: "amount",
            key: "amount",
            align: "right",
            className: "fw-700",
            render: (price) => {
              return <>{defaultCurrency + "" + price}</>;
            },
          },

          {
            title: "Discount", //tempory renaming to move the ticket as requested by gaurang,
            dataIndex: "discountAmount",
            key: "discountAmount",
            align: "right",
            className: "fw-700",
            render: (price) => {
              return <>{price ? defaultCurrency + "" + price : ""}</>;
            },
            // render: (price) => {
            //   return <>{defaultCurrency + "" + Math.abs(Number(price)).toFixed(2)}</>;
            // },
          },
          {
            title: messages.isTareWeightSupported[lan],
            dataIndex: "isTareWeightSupported",
            key: "isTareWeightSupported",
            align: "right",
          },
          {
            title: messages.tareType[lan],
            dataIndex: "tareType",
            key: "tareType",
            align: "right",
            render: (type) => {
              return <>{type == 'fixed' ? "Fixed" : "Variable"}</>;
            },
          },
          {
            title: messages.tareWeight[lan],
            dataIndex: "packageWeight",
            key: "packageWeight",
            align: "right",
          },
          {
            title: messages.actualWeight[lan],
            dataIndex: "actualWeight",
            key: "actualWeight",
            align: "right",
          },
          {
            title: messages.adjustedWeight[lan],
            dataIndex: "unitsold",
            key: "unitsold",
            align: "right",
          },
          {
            title: messages.UnitofMeasurement[lan],
            dataIndex: "weightUnitCode",
            key: "weightUnitCode",
            align: "right",
          }
        ];
  } else {
    columns = [
      {
        icon: "name",
        dataIndex: "name",
        key: "name",
        fixed: "left",
        width: 50,
        padding: "8px 0 8px 10px!important",
        className: "first-p-r-0",
        render: (name) => (
          <>
            <div key={name}>
              <Avatar className="bg-primary fw-700">{name?.charAt(0)}</Avatar>
            </div>
          </>
        ),
      },
      {
        title: "Item name",
        dataIndex: "name",
        key: "name",
        fixed: "left",
        width: 220,
      },
    ];
    // console.log("dateColums", dateColums)
    for (let x in dateColums) {
      columns.push({
        title: dateColums[x],
        dataIndex: dateColums[x],
        key: dateColums[x],
        align: "right",
        width: 100,
        className: "fw-700",
        render: (price) => {
          return (
            <>
              {summaryType === "amount" ? defaultCurrency + "" + price : price}
            </>
          );
        },
      });
    }
  }
  const data = summaryType === "amount" ? dataSource.amountData : dataSource.soldData;
  const ITU_cellP = getUserData()?.ITU_cellP === true || getUserData()?.ITU_cellpay === "true";

  if (data && data.length > 0) {
    if (ITU_cellP) {
      if (data[0].hasOwnProperty("merchantFee")) {
        columns.push({
          title: messages.merchantFee[lan],
          dataIndex: "merchantFee",
          key: "merchantFee",
          align: "right",
          className: "fw-700",
          render: (price) => {
            return <>{price ? defaultCurrency + "" + price : ""}</>;
          },
        });
      }
      if (data[0].hasOwnProperty("feeType")) {
        columns.push({
          title: messages.feeType[lan],
          dataIndex: "feeType",
          key: "feeType",
          align: "right",
        });
      }
      if (data[0].hasOwnProperty("netAmount")) {
        columns.push({
          title: messages.netAmount[lan],
          dataIndex: "netAmount",
          key: "netAmount",
          align: "right",
          className: "fw-700",
          render: (price) => {
            return <>{price ? defaultCurrency + "" + price : ""}</>;
          },
        });
      }
    }
  }

  // console.log("columns", columns)
  // if (isRestaurant || isRestaurant === "true") {
  //   columns.push({
  //     title: messages.SplitType[lan],
  //     dataIndex: "split_type",
  //     key: "split_type",
  //     align: "right",
  //     render: (type) => {
  //       return (
  //         <span style={{ textTransform: "capitalize" }}>
  //           {type}
  //         </span>
  //       );
  //     },
  //   });
  // }
  return (
    <Table
      rowKey={(record, index) => index}
      columns={columns}
      dataSource={data}
      pagination={false}
      scroll={
        columns.length < 4 ? undefined : { x: Math.max(columns.length * 180, 1500) }
      }
      className="itemsummaryTable"
    />
  );
};
export default Itemsummarylist;
